var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoCorreo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono correo"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    cx: 12.1875,
    cy: 12.1876,
    r: 12.1876,
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.95063 7.12888L11.3542 12.1285C11.6066 12.4131 11.9664 12.5742 12.3423 12.5742C12.7182 12.5742 13.0834 12.4131 13.3304 12.1285L17.6587 7.22018C17.6963 7.17722 17.7393 7.15037 17.7823 7.12352C17.5997 7.04296 17.3956 7 17.1862 7H7.49839C7.29432 7 7.101 7.04296 6.92378 7.11277C6.93452 7.11814 6.93989 7.12351 6.95063 7.12888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.448 7.69824C18.4265 7.74657 18.3997 7.80027 18.3621 7.84323L14.0337 12.7516C13.6041 13.2403 12.9866 13.5195 12.3368 13.5195C11.687 13.5195 11.0694 13.2403 10.6398 12.7516L6.23627 7.75194C6.22553 7.7412 6.22016 7.73046 6.21479 7.71972C6.08054 7.94527 5.99998 8.20841 5.99998 8.49302V15.2594C5.99998 16.0864 6.67126 16.7577 7.49826 16.7577H17.1807C18.0077 16.7577 18.6789 16.0864 18.6789 15.2594V8.49302C18.6789 8.19767 18.593 7.92916 18.448 7.69824Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCorreo);
export default __webpack_public_path__ + "static/media/icono-correo.c84231958ed6aa5fee2584b808648f30.svg";
export { ForwardRef as ReactComponent };